export const getCurrentPageId = () => {
  let pathArray = location.pathname.split('/');
  const val = pathArray[pathArray.length - 1];
  if (!val) return null;
  return parseInt(val);
}
